<div class="main-content profile-editor-page ticket-request-page ticket-request-page--llena">
  <div class="container-fluid">
    <form [formGroup]='options'>
      <section class="profile-editor-page__hero">
        <div class="ticket-request-page__heading">
          <span class="ticket-request-page__badge" aria-hidden="true"><i class="material-icons">school</i></span>
          <div class="profile-editor-page__copy">
            <h1>Solicitud de capacitación</h1>
            <p>La capacitación que necesitas: curso, fecha y quiénes la toman.</p>
          </div>
        </div>

        <div class="profile-editor-page__hero-actions">
          <button type="button" class="app-form-btn app-form-btn--secondary" (click)="limpiar()">Limpiar</button>
          <button type="button" class="app-form-btn app-form-btn--secondary" (click)='onCloseClick()'>Cancelar</button>
          <button type="button" class="app-form-btn app-form-btn--primary" (click)='guardar()' [disabled]="!options.valid">Guardar</button>
        </div>
      </section>

      <section class="ticket-request-page__meta" aria-label="Datos generales">
        <div class="ticket-request-page__meta-item">
          <span>Nombre solicitante</span>
          <strong>{{nombreSolicitante}}</strong>
        </div>
        <div class="ticket-request-page__meta-item">
          <span>&Aacute;rea solicitante</span>
          <strong>{{areaSolicitante}}</strong>
        </div>
        <div class="ticket-request-page__meta-item">
          <span>Fecha de solicitud</span>
          <strong>{{fechaSolicitud | date: ' d  MMMM y '}}</strong>
        </div>
        <mat-form-field appearance="outline" subscriptSizing="dynamic"
          class="profile-editor-page__field ticket-request-page__meta-field">
          <mat-label>Prioridad</mat-label>
          <mat-select required formControlName='prioridadCtrl' [(ngModel)]="prioridad">
            <mat-option *ngFor="let items of prioridades" [value]="items">{{items.nombre}}</mat-option>
          </mat-select>
          <mat-error *ngIf=' options.controls.prioridadCtrl.invalid && (options.controls.prioridadCtrl.dirty || options.controls.prioridadCtrl.touched) && options.controls.prioridadCtrl.errors.required'>
            El campo es requerido.
          </mat-error>
        </mat-form-field>
      </section>

      <div class="row profile-editor-page__layout ticket-request-page__layout">
        <div class="col-xl-6">
          <section class="profile-editor-page__card ticket-request-page__card--grow">
            <div class="profile-editor-page__card-header">
              <div class="profile-editor-page__card-title">
                <i class="material-icons">menu_book</i>
                <span>Detalle de capacitaci&oacute;n</span>
              </div>
            </div>

            <div class="profile-editor-page__card-body">
              <div class="ticket-request-page__grid">
                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="profile-editor-page__field">
                  <mat-label>Nombre del curso</mat-label>
                  <input matInput aria-label="Nombre del curso" formControlName='nombreCursoCtrl' [(ngModel)]="nombreCurso" required>
                  <mat-error
                    *ngIf=' options.controls.nombreCursoCtrl.invalid && (options.controls.nombreCursoCtrl.dirty || options.controls.nombreCursoCtrl.touched) && options.controls.nombreCursoCtrl.errors.required'>
                    El campo es requerido.
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="profile-editor-page__field">
                  <mat-label>Tema requerido</mat-label>
                  <input matInput aria-label="Tema requerido" formControlName='temaCursoCtrl' [(ngModel)]="temaCurso" required>
                  <mat-error *ngIf=' options.controls.temaCursoCtrl.invalid && (options.controls.temaCursoCtrl.dirty || options.controls.temaCursoCtrl.touched) && options.controls.temaCursoCtrl.errors.required'>
                    El campo es requerido.
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="profile-editor-page__field">
                  <mat-label>Nivel</mat-label>
                  <mat-select required formControlName='nivelCtrl' [(ngModel)]="nivel">
                    <mat-option *ngFor="let items of niveles" [value]="items">{{items}}</mat-option>
                  </mat-select>
                  <mat-error
                    *ngIf=' options.controls.nivelCtrl.invalid && (options.controls.nivelCtrl.dirty || options.controls.nivelCtrl.touched) && options.controls.nivelCtrl.errors.required'>
                    El campo es requerido.
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="profile-editor-page__field">
                  <mat-label>Fecha de capacitaci&oacute;n</mat-label>
                  <input matInput [matDatepicker]="picker2" aria-label="Fecha de capacitaci&oacute;n"
                    name="fechaCapacitacion" [(ngModel)]="fechaCapacitacion" formControlName="fechaCapacitacionCrtl" required
                    [min]="fechaSolicitud">
                  <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                  <mat-datepicker #picker2></mat-datepicker>
                  <mat-error *ngIf="options.controls.fechaCapacitacionCrtl.invalid">
                    Campo obligatorio
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="profile-editor-page__field ticket-request-page__span-all">
                  <mat-label>Objetivo del curso</mat-label>
                  <mat-select required formControlName='objetivoCtrl' [(ngModel)]="objetivo">
                    <mat-option *ngFor="let items of objetivos" [value]="items">{{items}}</mat-option>
                  </mat-select>
                  <mat-error
                    *ngIf=' options.controls.objetivoCtrl.invalid && (options.controls.objetivoCtrl.dirty || options.controls.objetivoCtrl.touched) && options.controls.objetivoCtrl.errors.required'>
                    El campo es requerido.
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="ticket-request-page__fill">
                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="profile-editor-page__field">
                  <mat-label>Justificaci&oacute;n del solicitante</mat-label>
                  <textarea required matInput aria-label="Justificaci&oacute;n del solicitante" formControlName='justificacionCtrl'
                    [(ngModel)]="justificacion" maxlength="512" rows="3"
                    oninput="this.value = this.value.trim().charAt(0).toUpperCase() + this.value.slice(1)"></textarea>
                  <mat-error
                    *ngIf=' options.controls.justificacionCtrl.invalid && (options.controls.justificacionCtrl.dirty || options.controls.justificacionCtrl.touched) && options.controls.justificacionCtrl.errors.required'>
                    El campo es requerido.
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="profile-editor-page__field">
                  <mat-label>Observaciones</mat-label>
                  <textarea required matInput aria-label="Observaciones" formControlName='observacionesCtrl'
                    [(ngModel)]="observaciones" maxlength="512" rows="3"
                    oninput="this.value = this.value.trim().charAt(0).toUpperCase() + this.value.slice(1)"></textarea>
                  <mat-error
                    *ngIf=' options.controls.observacionesCtrl.invalid && (options.controls.observacionesCtrl.dirty || options.controls.observacionesCtrl.touched) && options.controls.observacionesCtrl.errors.required'>
                    El campo es requerido.
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </section>
        </div>

        <div class="col-xl-6">
          <section class="profile-editor-page__card ticket-request-page__card--grow">
            <div class="profile-editor-page__card-header">
              <div class="profile-editor-page__card-title">
                <i class="material-icons">groups</i>
                <span>Seleccionar personal a capacitar</span>
              </div>
            </div>

            <div class="profile-editor-page__card-body ticket-request-page__people">
              <div class="ticket-request-page__grid">
                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="profile-editor-page__field">
                  <mat-label>Filtro &aacute;rea</mat-label>
                  <mat-select (selectionChange)="filtrarEmpleadosPorArea($event)" selected="selected">
                    <mat-option>
                      <ngx-mat-select-search [formControl]="formArea" [placeholderLabel]="'Buscar...'"
                        [noEntriesFoundLabel]="'No se encontro información'">
                      </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let item of filterArea  | async" [value]="item">{{item.area}}</mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="profile-editor-page__field">
                  <mat-label>Filtro nombre</mat-label>
                  <input matInput type="text" id="nombreEmpleado" aria-label="Filtro nombre" [(ngModel)]="nombreEmpleado" name="nombreEmpleado" [ngModelOptions]="{standalone: true}"
                    (keyup)="filtrarEmpleadosPorNombre($event)" maxlength="80">
                </mat-form-field>
              </div>

              <div class="ticket-request-page__picker">
                <div class="ticket-request-page__list">
                  <mat-selection-list #listaDisponible>
                    <mat-list-option *ngFor="let opcion of listaFiltrada" [value]="opcion"> {{
                      opcion.persona.nombreCompleto }} </mat-list-option>
                  </mat-selection-list>
                </div>
                <div class="ticket-request-page__actions ticket-request-page__actions--column">
                  <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact" (click)="seleccionarTodosDisponibles()">Seleccionar todos</button>
                  <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact" (click)="deseleccionarTodosDisponibles()">Deseleccionar todos</button>
                  <button type="button" class="app-form-btn app-form-btn--primary app-form-btn--compact" (click)="agregarOpcionesSeleccionadas()">Agregar</button>
                </div>
              </div>

              <h3 class="ticket-request-page__subtitle">Personal a capacitar</h3>
              <div class="ticket-request-page__picker" *ngIf="listaPersonal.length>0">
                <div class="ticket-request-page__list">
                  <mat-selection-list #listaSeleccionada>
                    <mat-list-option *ngFor="let opcion of listaPersonal" [value]="opcion"> {{
                      opcion.persona.nombreCompleto }} </mat-list-option>
                  </mat-selection-list>
                </div>
                <div class="ticket-request-page__actions ticket-request-page__actions--column">
                  <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact" (click)="seleccionarTodosCapacitar()">Seleccionar todos</button>
                  <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact" (click)="deseleccionarTodosCapacitar()">Deseleccionar todos</button>
                  <button type="button" class="app-form-btn app-form-btn--danger app-form-btn--compact" (click)="eliminarOpcionesSeleccionadas()">Eliminar</button>
                </div>
              </div>
              <p class="ticket-request-page__empty" *ngIf="listaPersonal.length === 0">
                <i class="material-icons" aria-hidden="true">group_add</i>
                <span>Marca a las personas en la lista de arriba y pulsa «Agregar».</span>
              </p>
            </div>
          </section>
        </div>
      </div>
    </form>
  </div>
</div>